module.exports = __webpack_public_path__ + "img/智能识别--人像识别.107c70d6.png";